import { Injectable } from "@angular/core";
import * as XLSX from "xlsx";
import { ExcelDataProcessor, ParsedExcelData } from "@packages/shared-business";

@Injectable({
  providedIn: "root",
})
export class XlsxService {
  /**
   * Service for read and get data as JSON from EXCEL file.
   * Wraps XLSX library with framework-agnostic data processing
   */
  constructor() {}

  async uploadXlsx(event: any): Promise<ParsedExcelData> {
    return new Promise(async (resolve, reject) => {
      /* wire up file reader */
      const target: DataTransfer = <DataTransfer>event.target;
      if (target.files.length !== 1) {
        reject(new Error("Cannot use multiple files"));
        return;
      }

      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files[0]);

      reader.onload = (e: any) => {
        try {
          /* create workbook */
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, {
            type: "binary",
            cellDates: true,
            dateNF: "yyyy-mm-dd",
          });

          /* selected the first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* Convert to 2D array */
          const rawData: any[][] = XLSX.utils.sheet_to_json(ws, {
            header: 1,
            raw: false,
            dateNF: "yyyy-mm-dd",
          });

          /* Use framework-agnostic processor */
          const parsedData = ExcelDataProcessor.parseExcelData(rawData, {
            skipSerialNumbers: true,
          });

          resolve(parsedData);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  async export(data: any[], name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const WS = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, WS, name);
        XLSX.writeFile(wb, name + ".xlsx");
        resolve(WS);
      } catch (error) {
        reject(error);
      }
    });
  }
}
